module.exports = __webpack_public_path__ + "static/1286428994.71810308.jpg";